import { render, staticRenderFns } from "./ReviewList.vue?vue&type=template&id=5941cae4&scoped=true"
import script from "./ReviewList.vue?vue&type=script&lang=js"
export * from "./ReviewList.vue?vue&type=script&lang=js"
import style0 from "./ReviewList.vue?vue&type=style&index=0&id=5941cae4&prod&lang=scss&scoped=true"
import style1 from "./ReviewList.vue?vue&type=style&index=1&id=5941cae4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5941cae4",
  null
  
)

export default component.exports